import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";

import axios from "axios";

import { Button } from "components";

import nowLogo from "assets/img/hr-logo-full.png";
import Cookies from "universal-cookie";
import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
import {Camera} from "react-camera-pro";
import styled from 'styled-components';
import canvas from "canvas";
import imageCompression from 'browser-image-compression';
import moment from "moment";
import "moment/locale/es";
import { duration } from "moment";
import { Space } from "antd";
import { SmileOutlined, AppstoreOutlined } from "@ant-design/icons";

const cookies = new Cookies();
const videoRef = React.createRef();
const canvasRef = React.createRef();
const imageRef = React.createRef();
const camera = React.createRef();

// const API = "https://oficina.nadunet.es/api/rest/";
const API = !window.location.host.includes("localhost") ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
const DO_LOGIN_URL = "user/login";
const LOGIN_URL = "nadulogin_resources/login";
const GET_TOKEN_URL = "user/token";
const DO_LOGOUT_URL = "user/logout";
const recuperarPassStyle = {
  textAlign: "center"
};
const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
const PIN_ACCESS = "pin";
const FACE_ACCESS = "face";

// Login statuses
const WAITING_FACE = "waiting-face";
const RECOGNIZING_FACE = "recognizing-face";
const ERROR_FACE = "error-face";
const OK_FACE = "ok-face";
const START_CHECKIN = "start-checkin";
const FINISH_CHECKIN = "finish-checkin";

// Face functions
const LEARN = "learn-face";
const LOGIN = "face-login";
const CHECKIN = "checkin-hr";

var detectFaces = false;
var modelsLoaded = false;
var face_function = "";
class CheckIn extends React.Component {
  constructor(props) {
    super(props);
    let fields = {
      login: "dniField",
      pass: "passField"
    };
    // localStorage.removeItem('hr_api_key');
    this.state = {
      fields: fields,
      [fields.login]: "",
      [fields.pass]: "",
      username: "",
      loginError: false,
      isLogging: false,
      apiKey: localStorage.getItem('hr_api_key'),
      numberOfCameras: 0,
      activeDeviceId: undefined,
      detectionTime: 1000,
      loginStatus: WAITING_FACE,
      countdown: 0,
      selectedMethod: null
      // randomBg: randomBg
    };
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
    this.imageRef = React.createRef();
    this.camera = React.createRef();

    this.getPairingCode = this.getPairingCode.bind(this);
    this.checkPairing = this.checkPairing.bind(this);
    this.buildCheckinContent = this.buildCheckinContent.bind(this);
    this.buildCheckinFace = this.buildCheckinFace.bind(this);
    this.setNumberOfCameras = this.setNumberOfCameras.bind(this);
    this.setDevices = this.setDevices.bind(this);
    this.detectFace = this.detectFace.bind(this);
    this.recognizeDetectedFace = this.recognizeDetectedFace.bind(this);
    this.recognizeFace = this.recognizeFace.bind(this);
    this.checkinDetected = this.checkinDetected.bind(this);
    this.analyzeRequestError = this.analyzeRequestError.bind(this);
    this.checkInCountdown = this.checkInCountdown.bind(this);
    this.buildSelectMethod = this.buildSelectMethod.bind(this);
    this.buildCheckinPIN = this.buildCheckinPIN.bind(this);
  }
  componentDidMount() {
    if (!this.state.apiKey) this.getPairingCode();
    this.faceDetection();
    (async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(i => i.kind == 'videoinput');
      this.setDevices(videoDevices);
    })();
  }
  analyzeRequestError(response) {
    // return;
    if (response && response.error_code && response.error_code === 666) {
      localStorage.removeItem("hr_api_key");
      this.setState({ apiKey: null });
      this.getPairingCode();
    }
  }
  async getPairingCode() {
    if (this.state.gettingPairingCode) return;
    this.setState({ gettingPairingCode: true });
    this.props.userData.generatePairingCode().then(result => {
      this.setState({
        gettingPairingCode: false,
        pairingCode: result.ok ? result.pairing_code : null
      });
      if (result.ok) {
        this.timer = setInterval( function() {
          this.checkPairing();
        }.bind(this), 2000);
      }
    })
    .catch((error) => {
      this.setState({
        gettingPairingCode: false
      });
      // Error 😨
      console.log("Error al cargar el código de emparejamiento: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async checkPairing() {
    if (this.state.isCheckingPairing) return;
    this.setState({ isCheckingPairing: true });
    this.props.userData.checkPairing(this.state.pairingCode).then(result => {
      this.setState({
        isCheckingPairing: false
      });
      if (result) {
        if (result.ok) {
          if (result.paired) {
            this.setState({ apiKey: result.ok ? result.api_key : null });
            localStorage.setItem("hr_api_key", result.api_key);
            if (this.timer) clearInterval(this.timer);
          }
        }
      }
    })
    .catch((error) => {
      this.setState({
        isCheckingPairing: false
      });
      // Error 😨
      console.log("Error al comprobar el código de emparejamiento: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  setNumberOfCameras(cameras) {
    this.setState({ numberOfCameras: cameras });
  }
  handleChange(field, event) {
    this.setState({ [field]: event.target.value });
  }
  faceDetection = async (force) => {
    setInterval(async () => {
      // console.info("In faceDetection. Should we proceed?");
      if (!this.state.apiKey && !force) return;
      if (this.state.isRecognizingFace) return;
      if (this.state.apiKey || force) {
        // console.info("In faceDetection. face_function", face_function);
        // console.info("In faceDetection. this.state.loginStatus", this.state.loginStatus);
        if (this.state.loginStatus !== WAITING_FACE)
          return;
        // console.info("Yes, starting face detection");
        if (camera.current) {
          try {
            let photo = camera.current.takePhoto();
            // console.info("Photo taken", photo);
            imageRef.current.src = photo;
            // console.log("foto obtenida", photo);
            // if (face_function === LOGIN || face_function === CHECKIN) {
              this.detectFace(photo);
              return;
            // }
            console.info("Nothing done with the camera");
            return;
          } catch (error) {
            console.log("Error al cargar la imagen de la cámara");
          }
        }
      } else {
        // console.info("Nope, let's try again later");
      }
    }, this.state.detectionTime);
  };
  async detectFace(imgBase64) {
    // if (this.state.loginStatus === RECOGNIZING_FACE) return;
    if (this.state.isRecognizingFace) return;
    this.setState({
      isRecognizingFace: true
    });
    let face = await this.compressImage(imgBase64);
    this.props.userData
      .detectFace(face, this.state.apiKey)
      .then(result => {
        if (result.ok) {
          if (result.detection) {
            if (!result.multiple) {
              this.checkinDetected(result.uuid);
            } else {
              this.setState({
                isRecognizingFace: false
              });
              console.log("Error al detectar la cara: Hay varias caras");
            }
          } else {
            this.setState({
              isRecognizingFace: false
            });
            console.log("Error al detectar la cara: No hay cara");
          }
        } else {
          this.setState({
            isRecognizingFace: false
          });
          this.analyzeRequestError(result);
          // Error 😨
          console.log("Error al detectar la cara: " + result.error);
          // this.setState({
          //   loginStatus: ERROR_FACE
          // });
          // setTimeout( function() {
          //   this.setState({
          //     loginStatus: WAITING_FACE
          //   })
          // }.bind(this), 2000);
        }
      })
      .catch((error) => {
        this.setState({
          isRecognizingFace: false
        });
        // Error 😨
        console.log("Error al detectar la cara: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  async recognizeDetectedFace(face_uuid) {
    this.props.userData
      .recognizeDetectedFace(face_uuid)
      .then(result => {
        if (result.ok) {
          console.log("Cara reconocida", result);
          this.setState({
            isRecognizingFace: false
          });
          return;
        } else {
          this.setState({
            loginStatus: ERROR_FACE
          });
          setTimeout( function() {
            this.setState({
              loginStatus: WAITING_FACE
            })
          }.bind(this), 2000);
          this.analyzeRequestError(result);
        }
      })
      .catch((error) => {
        this.setState({
          sendingFaces: false
        });
        // Error 😨
        console.log("Error al añadir las caras: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  async compressImage(imgBase64) {
    var options = {
      maxSizeMB: 0.05, // 50KB
      maxWidthOrHeight: 1920,
      useWebWorker: true
      // onProgress: this.imageUploadStatus
    };
    // Gets compressed base64(from File(from original base64))
    return await imageCompression.getDataUrlFromFile(
      await imageCompression(
        await imageCompression.getFilefromDataUrl(imgBase64, "image.png"),
        options
      )
    );
  }
  async recognizeFace(face) {
    if (this.state.loginStatus === RECOGNIZING_FACE) return;
    this.setState({
      loginStatus: RECOGNIZING_FACE
    });
    // let face = await this.compressImage(imgBase64);
    this.props.userData
      .faceLogin(face)
      .then(result => {
        if (result.ok) {
          let name = result.user.field_nombre_completo.und[0].value;
          if (name) name = name.split(" ");
          if (name && name.length > 0) name = name[0];
          this.setState({
            loginStatus: OK_FACE,
            username: name,
            loginResult: result,
            isRecognizingFace: false
          });
          setTimeout( function() {
            this.setState({
              selectedMethod: null,
              loginStatus: WAITING_FACE,
              username: null,
              loginResult: null
            });
          }.bind(this), 2000);
        } else {
          this.setState({
            loginStatus: ERROR_FACE,
            isRecognizingFace: false
          });
          setTimeout( function() {
            this.setState({
              loginStatus: WAITING_FACE
            })
          }.bind(this), 2000);
          this.analyzeRequestError(result);
        }
      })
      .catch((error) => {
        this.setState({
          loginStatus: WAITING_FACE,
          isRecognizingFace: false
        })
        // Error 😨
        console.log("Error al reconocer la cara: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  checkInCountdown(start, abort) {
    if (abort) {
      this.setState({
        countdown: 0
      });
      return;
    }
    // Si nos piden empezar, inicializamos el contador
    // y volvemos a llamar en 1 segundo
    if (start) {
      this.setState({ countdown: 15 });
      setTimeout( function() {
        this.checkInCountdown();
      }.bind(this), 1000);
    } else {
      if (this.state.countdown && this.state.countdown > 0) {
        let countdown = this.state.countdown - 1;
        this.setState({ countdown: this.state.countdown - 1 });
        if (countdown === 0) {
          this.setState({
            selectedMethod: null,
            countdown: 0,
            loginStatus: WAITING_FACE,
            username: null,
            loginResult: null
          });
        } else {
          setTimeout( function() {
            this.checkInCountdown();
          }.bind(this), 1000);
        }
      }
    }
  }
  async checkinDetected(face) {
    if (this.state.loginStatus === RECOGNIZING_FACE) return;
    this.setState({
      loginStatus: RECOGNIZING_FACE
    });
    // let face = await this.compressImage(imgBase64);
    this.props.userData
      .checkinDetected(face, this.state.apiKey)
      .then(result => {
        if (result.ok) {
          console.log("Checkin correcto!", result);
          let name = result.name;
          // if (name) name = name.split(" ");
          // if (name && name.length > 0) name = name[0];
          let checkin = null;
          if (result.active_checkin) {
            checkin = result.checkin;
            checkin.active = true;
          }
          this.setState({
            loginStatus: OK_FACE,
            username: name,
            loginResult: result,
            isRecognizingFace: false,
            checkin: checkin,
            employee: result.employee
          });
          this.checkInCountdown(true);
        } else {
          this.setState({
            loginStatus: ERROR_FACE,
            isRecognizingFace: false
          });
          setTimeout( function() {
            this.setState({
              loginStatus: WAITING_FACE
            })
          }.bind(this), 2000);
          this.analyzeRequestError(result);
        }
      })
      .catch((error) => {
        this.setState({
          loginStatus: WAITING_FACE,
          isRecognizingFace: false
        });
        // Error 😨
        console.log("Error al reconocer la cara: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  async checkinDetectedPIN(pin) {
    if (this.state.loginStatus === RECOGNIZING_FACE) return;
    this.setState({
      loginStatus: RECOGNIZING_FACE
    });
    // let face = await this.compressImage(imgBase64);
    this.props.userData
      .checkinDetectedPIN(pin, this.state.apiKey)
      .then(result => {
        this.setState({ accessPIN: null });
        if (result.ok) {
          console.log("Checkin correcto!", result);
          let name = result.name;
          // if (name) name = name.split(" ");
          // if (name && name.length > 0) name = name[0];
          let checkin = null;
          if (result.active_checkin) {
            checkin = result.checkin;
            checkin.active = true;
          }
          this.setState({
            loginStatus: OK_FACE,
            username: name,
            loginResult: result,
            isRecognizingFace: false,
            checkin: checkin,
            employee: result.employee
          });
          this.checkInCountdown(true);
        } else {
          this.setState({
            loginStatus: ERROR_FACE,
            isRecognizingFace: false
          });
          setTimeout( function() {
            this.setState({
              loginStatus: WAITING_FACE
            })
          }.bind(this), 2000);
          this.analyzeRequestError(result);
        }
      })
      .catch((error) => {
        this.setState({
          loginStatus: WAITING_FACE,
          isRecognizingFace: false,
          accessPIN: null
        });
        // Error 😨
        console.log("Error al reconocer la cara: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  async startCheckin() {
    if (this.state.isStartingCheckin) return;
    this.setState({ isStartingCheckin: true });
    this.props.userData.startCheckin(this.state.employee.uuid, this.state.apiKey).then(result => {
      this.setState({
        isStartingCheckin: false
      });
      if (result) {
        if (result.ok) {
          this.setState({
            loginStatus: START_CHECKIN,
            isRecognizingFace: false
          });
          setTimeout( function() {
            this.setState({
              selectedMethod: null,
              loginStatus: WAITING_FACE
            })
          }.bind(this), 3000);
          this.analyzeRequestError(result);
        } else {
          this.checkInCountdown(true);
        }
      }
    })
    .catch((error) => {
      this.setState({
        isStartingCheckin: false
      });
      // Error 😨
      console.log("Error al comprobar el código de emparejamiento: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async finishCheckin() {
    if (this.state.isFinishingCheckin) return;
    this.setState({ isFinishingCheckin: true });
    this.props.userData.finishCheckin(this.state.employee.uuid, this.state.apiKey).then(result => {
      this.setState({
        isFinishingCheckin: false
      });
      if (result) {
        if (result.ok) {
          this.setState({
            loginStatus: FINISH_CHECKIN,
            isRecognizingFace: false
          });
          setTimeout( function() {
            this.setState({
              selectedMethod: null,
              loginStatus: WAITING_FACE
            })
          }.bind(this), 4000);
          this.analyzeRequestError(result);
        } else {
          this.checkInCountdown(true);
        }
      }
    })
    .catch((error) => {
      this.setState({
        isFinishingCheckin: false
      });
      // Error 😨
      console.log("Error al comprobar el código de emparejamiento: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  setDevices(devices) {
    this.setState({ devices: devices });
  }

  // Start of Build content section
  buildCheckinContent() {
    let bodyContent = null;
    let footerContent = null;
    if (!this.state.apiKey) {
      if (this.state.gettingPairingCode) {
        bodyContent = (
          <span className="checkin-pairing-code">
            <b>
              <i className="now-ui-icons arrows-1_refresh-69 spin" />
            </b>
          </span>
        );
        footerContent = null;
      } else {
        bodyContent = (
          <span className="checkin-pairing-code">
            <b>{this.state.pairingCode}</b>
          </span>
        );
        footerContent = <span className="checkin-pairing-code-explanation">Introduce este código en tu panel de administración</span>;
      }
      return (
        <div>
          <div className="full-page-content">
            <div className="login-page" id="hr-login">
              <Container>
                <Col xs={12} className="ml-auto mr-auto">
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="now-logo" />
                      </div>
                    </CardHeader>
                    <CardBody className="text-center">{bodyContent}</CardBody>
                    <CardFooter className="text-center">{footerContent}</CardFooter>
                  </Card>
                </Col>
              </Container>
            </div>
          </div>
          <div
            className="full-page-background"
            // style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
          />
        </div>
      );
    } else {
      switch (this.state.selectedMethod) {
        case FACE_ACCESS:
          return this.buildCheckinFace();
        case PIN_ACCESS:
          return this.buildCheckinPIN();
        default:
          return this.buildSelectMethod();
      }
    }
  }
  buildCheckinFace() {
    let bodyContent = null;
    let footerContent = null;
    let bodyText = "";
    let footerText = "";
    let checkinDuration = null;
    let activeCheckin = this.state.checkin && this.state.checkin.active;

    if (this.state.loginStatus === OK_FACE && activeCheckin) {
      // console.log("tiempo fichaje (this.state.checkin)", this.state.checkin);
      let start = moment.unix(parseInt(this.state.checkin.start));
      // console.log("tiempo fichaje (start)", start);
      let end = moment();
      // let duration = moment.duration(end.diff(start));
      // // duration in hours
      // var hours = parseInt(duration.asHours());
      // var minutes = parseInt(duration.asMinutes() % 60);
      // var seconds = parseInt(duration.asSeconds() % 60);
      // let durationd = end.diff(start, "days");
      // let durationh = end.diff(start, "hours") - durationd*24;
      // let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
      // let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
      // durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
      // durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
      // durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
      // durations = durations === 0? "" : durations + (durations > 1 ? " segs " : " seg ");
      // durations = "";
      // // checkinDuration = (durationd + durationh + durationm + durations);
      // checkinDuration = (durationd + durationh + durationm + durations);

      checkinDuration = [];
      let dif = moment.duration(end.diff(start));
      let hours = dif.hours();
      let minutes = dif.minutes();
      let seconds = dif.seconds();
      console.log("hours", hours);
      if (hours > 0) checkinDuration.push(hours + "h");
      if (minutes > 0) checkinDuration.push(minutes + "m");
      if (seconds > 0) checkinDuration.push(seconds + "s");
      console.log("checkinDuration", checkinDuration);
      // console.log(dif.humanize());
      checkinDuration = checkinDuration.join(" ");
      console.log("checkingDuration", checkinDuration);
    }

    switch (this.state.loginStatus) {
      case WAITING_FACE:
        bodyText = "hola 😊";
        footerText = "Acércate para fichar";
        break;
      case RECOGNIZING_FACE:
        bodyText = "Mmm...";
        footerText = (
          <span>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
             Reconociendo
          </span>
        );
        break;
      case ERROR_FACE:
        bodyText = "No sé 😟";
        footerText = "No te he reconocido";
        break;
      case OK_FACE:
        bodyText =  <span>
                      <span>{this.state.username} 😊</span>
                      <span className="checkin-duration">{checkinDuration}</span>
                    </span>;
        footerText = activeCheckin ? "¿Ya has terminado?" : "¡Hola de nuevo!";
        break;
      case START_CHECKIN:
        bodyText =  <span>
                      <span>¡Ánimo! 🥰</span>
                    </span>;
        footerText = "Que vaya bien la jornada";
        break;
      case FINISH_CHECKIN:
        bodyText =  <span>
                      <span>¡Hasta pronto! 👋</span>
                    </span>;
        footerText = "Disfruta del tiempo libre";
        break;
      default:
        bodyText = "hola 😊";
        footerText = "Acércate para fichar";
        break;
    }
    bodyContent = (
      <span className="checkin-pairing-code">
        <b>{bodyText}</b>
      </span>
    );
    footerContent = (
      <div>
        <span className="checkin-pairing-code-explanation">{footerText}</span>
        {this.state.loginStatus === OK_FACE && 
          <Row className="checkin-actions">
            <Col xs={12} md={6}>
              <Button 
                block 
                color="success"
                size="sm"
                disabled={this.state.isStartingCheckin || this.state.isFinishingCheckin}
                onClick={() => {
                  this.checkInCountdown(false, true);
                  if (activeCheckin) {
                    this.finishCheckin();
                  } else {
                    this.startCheckin();
                  }
                  return;
                  // this.setState({ createCompany: false });
                }}
                >
                {this.state.isStartingCheckin ||
                this.state.isFinishingCheckin ? (
                  <i className="now-ui-icons arrows-1_refresh-69 spin" />
                ) : null}
                  {activeCheckin ? "Finalizar" : "Empezar"}
              </Button>
            </Col>
            <Col xs={12} md={6}>
              <Button 
                block 
                color="default" 
                size="sm"
                disabled={this.state.isStartingCheckin || this.state.isFinishingCheckin}
                onClick={() => {
                  this.checkInCountdown(false, true);
                  this.setState({
                    selectedMethod: null,
                    countdown: 0,
                    loginStatus: WAITING_FACE,
                    username: null,
                    loginResult: null
                  });
                  // this.setState({ createCompany: false });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>}
        <Row>
          <Col>
            <Button
              // block
              round
              color="danger"
              // color={this.state.isLogging ? "default" : "primary"}
              size="lg"
              // href=""
              // className="mb-3"
              onClick={() =>
                this.setState({ selectedMethod: null })
              }
            >
              <span>Cambiar método</span>
            </Button>
          </Col>
        </Row>
      </div>
    );
    // return (
    //   <Card className="card-login card-plain">
    //     <CardHeader>
    //       <div className="logo-container">
    //         <img src={nowLogo} alt="now-logo" />
    //       </div>
    //     </CardHeader>
    //     <CardBody className="text-center">{bodyContent}</CardBody>
    //     <CardFooter className="text-center">{footerContent}</CardFooter>
    //   </Card>
    // );
    return (
      <Wrapper>
        <div id="camera-container">
          <Camera
            ref={camera}
            aspectRatio="cover"
            numberOfCamerasCallback={i => this.setNumberOfCameras(i)}
            videoSourceDeviceId={this.state.activeDeviceId}
            errorMessages={{
              noCameraAccessible: 'No camera device accessible. Please connect your camera or try a different browser.',
              permissionDenied: 'Permission denied. Please refresh and give camera permission.',
              switchCamera:
                'It is not possible to switch camera to different one because there is only one video device accessible.',
              canvas: 'Canvas is not supported.',
            }}
          />
        </div>
        <div id="face-overlay" className="checkin">
          <Card className="card-login card-plain">
            <CardHeader>
              <div className="logo-container">
                <img src={nowLogo} alt="now-logo" />
              </div>
            </CardHeader>
            <CardBody className="text-center">{bodyContent}</CardBody>
            <CardFooter className="text-center">{footerContent}</CardFooter>
            {(this.state.countdown !== null && this.state.countdown > 0) && 
              <CardFooter className="text-center checkin-countdown">{"Se cancelará en " + this.state.countdown + "s"}</CardFooter>}
          </Card>
        </div>
        <img id="taken_photo" style={{ display: "none" }} ref={imageRef} />
      </Wrapper>
    );
  }
  buildSelectMethod() {
    return (
      <div className="full-page-content">
        <div className="login-page" id="hr-login">
          <Container>
            <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
              <Form>
                <Card className="card-login card-plain text-center">
                  <CardHeader>
                    <div className="logo-container">
                      <img src={nowLogo} alt="now-logo" />
                    </div>
                    <h4>
                      <b>Selecciona método</b>
                    </h4>
                  </CardHeader>
                  <CardFooter className="text-center">
                    <Row>
                      <Col xs={6}>
                        <Button
                          block
                          round
                          // color={this.state.isLogging ? "default" : "primary"}
                          size="lg"
                          // href=""
                          // className="mb-3"
                          onClick={() =>
                            this.setState({ selectedMethod: FACE_ACCESS })
                          }
                        >
                          <SmileOutlined style={{ fontSize: '32px' }}/>
                          <br />
                          <span>Cara</span>
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button
                          block
                          round
                          // color={this.state.isLogging ? "default" : "primary"}
                          size="lg"
                          // href=""
                          // className="mb-3"
                          onClick={() =>
                            this.setState({ selectedMethod: PIN_ACCESS })
                          }
                        >
                          <AppstoreOutlined style={{ fontSize: '32px' }}/>
                          <br />
                          <span>PIN</span>
                        </Button>
                      </Col>
                    </Row>
                    {/*<div style={recuperarPassStyle}>
                      <Link to="/recuperar">Recuperar contraseña</Link>
                    </div>*/}
                    {/* this.state.loginError && loginErrorMessage */}
                    {/* <div className="pull-right">
                      <h6>
                        <a href="#pablo" className="link footer-link">
                          Need Help?
                        </a>
                      </h6>
                    </div> */}
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
      </div>
    );
  }
  validateAccessPIN() {
    let result = true;
    const { accessPIN } = this.state;
    if (!accessPIN) return false;
    if (accessPIN.length < 1) return false;
    return result;
  }
  buildCheckinPIN() {
    let bodyContent = null;
    let footerContent = null;
    let bodyText = "";
    let footerText = "";
    let checkinDuration = null;
    let activeCheckin = this.state.checkin && this.state.checkin.active;

    if (this.state.loginStatus === OK_FACE && activeCheckin) {
      // console.log("tiempo fichaje (this.state.checkin)", this.state.checkin);
      let start = moment.unix(parseInt(this.state.checkin.start));
      // console.log("tiempo fichaje (start)", start);
      let end = moment();
      // let duration = moment.duration(end.diff(start));
      // // duration in hours
      // var hours = parseInt(duration.asHours());
      // var minutes = parseInt(duration.asMinutes() % 60);
      // var seconds = parseInt(duration.asSeconds() % 60);
      // let durationd = end.diff(start, "days");
      // let durationh = end.diff(start, "hours") - durationd*24;
      // let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
      // let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
      // durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
      // durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
      // durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
      // durations = durations === 0? "" : durations + (durations > 1 ? " segs " : " seg ");
      // durations = "";
      // // checkinDuration = (durationd + durationh + durationm + durations);
      // checkinDuration = (durationd + durationh + durationm + durations);

      checkinDuration = [];
      let dif = moment.duration(end.diff(start));
      let hours = dif.hours();
      let minutes = dif.minutes();
      let seconds = dif.seconds();
      console.log("hours", hours);
      if (hours > 0) checkinDuration.push(hours + "h");
      if (minutes > 0) checkinDuration.push(minutes + "m");
      if (seconds > 0) checkinDuration.push(seconds + "s");
      console.log("checkinDuration", checkinDuration);
      // console.log(dif.humanize());
      checkinDuration = checkinDuration.join(" ");
      console.log("checkingDuration", checkinDuration);
    }

    switch (this.state.loginStatus) {
      case WAITING_FACE:
        bodyText = <span>hola 😊<br />Introduce el PIN</span>;
        footerText = (
          <Row>
            <Col xs={12}>
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.accessPINFocus ? "input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons users_circle-08" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  placeholder="PIN"
                  onFocus={e => this.setState({ accessPINFocus: true })}
                  onBlur={e => this.setState({ accessPINFocus: false })}
                  value={this.state.accessPIN}
                  onChange={(e) => this.setState({ accessPIN: e.target.value})}
                />
              </InputGroup>
            </Col>
            <Col xs={12}>
              <Button
                block
                round
                color={"primary"}
                size="lg"
                // href=""
                // className="mb-3"
                disabled={!this.validateAccessPIN()}
                onClick={() =>
                  this.checkinDetectedPIN(this.state.accessPIN)
                }
              >
                <span>Fichar</span>
              </Button>
            </Col>
          </Row>
        );
        break;
      case RECOGNIZING_FACE:
        bodyText = "Mmm...";
        footerText = (
          <span>
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
             Reconociendo
          </span>
        );
        break;
      case ERROR_FACE:
        bodyText = "No sé 😟";
        footerText = "No te he reconocido";
        break;
      case OK_FACE:
        bodyText =  <span>
                      <span>{this.state.username} 😊</span>
                      <span className="checkin-duration">{checkinDuration}</span>
                    </span>;
        footerText = activeCheckin ? "¿Ya has terminado?" : "¡Hola de nuevo!";
        break;
      case START_CHECKIN:
        bodyText =  <span>
                      <span>¡Ánimo! 🥰</span>
                    </span>;
        footerText = "Que vaya bien la jornada";
        break;
      case FINISH_CHECKIN:
        bodyText =  <span>
                      <span>¡Hasta pronto! 👋</span>
                    </span>;
        footerText = "Disfruta del tiempo libre";
        break;
      default:
        bodyText = "hola 😊";
        footerText = "Acércate para fichar";
        break;
    }
    bodyContent = (
      <span className="checkin-pin-code">
        <b>{bodyText}</b>
      </span>
    );
    footerContent = (
      <div>
        <span className="checkin-pairing-code-explanation">{footerText}</span>
        {this.state.loginStatus === OK_FACE && 
          <Row className="checkin-actions">
            <Col xs={12} md={6}>
              <Button 
                block 
                color="success"
                size="sm"
                disabled={this.state.isStartingCheckin || this.state.isFinishingCheckin}
                onClick={() => {
                  this.checkInCountdown(false, true);
                  if (activeCheckin) {
                    this.finishCheckin();
                  } else {
                    this.startCheckin();
                  }
                  return;
                  // this.setState({ createCompany: false });
                }}
                >
                {this.state.isStartingCheckin ||
                this.state.isFinishingCheckin ? (
                  <i className="now-ui-icons arrows-1_refresh-69 spin" />
                ) : null}
                  {activeCheckin ? "Finalizar" : "Empezar"}
              </Button>
            </Col>
            <Col xs={12} md={6}>
              <Button 
                block 
                color="default" 
                size="sm"
                disabled={this.state.isStartingCheckin || this.state.isFinishingCheckin}
                onClick={() => {
                  this.checkInCountdown(false, true);
                  this.setState({
                    countdown: 0,
                    loginStatus: WAITING_FACE,
                    username: null,
                    loginResult: null
                  });
                  // this.setState({ createCompany: false });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>}
        <Row>
          <Col>
            <Button
              // block
              round
              color="danger"
              // color={this.state.isLogging ? "default" : "primary"}
              size="lg"
              // href=""
              // className="mb-3"
              onClick={() =>
                this.setState({ selectedMethod: null })
              }
            >
              <span>Cambiar método</span>
            </Button>
          </Col>
        </Row>
      </div>
    );
    // return (
    //   <Card className="card-login card-plain">
    //     <CardHeader>
    //       <div className="logo-container">
    //         <img src={nowLogo} alt="now-logo" />
    //       </div>
    //     </CardHeader>
    //     <CardBody className="text-center">{bodyContent}</CardBody>
    //     <CardFooter className="text-center">{footerContent}</CardFooter>
    //   </Card>
    // );
    return (
      <div className="full-page-content">
        <div className="login-page" id="hr-login">
          <Container>
            <Col xs={12} md={8} lg={6} className="ml-auto mr-auto">
              <Card className="card-login card-plain">
                <CardHeader>
                  <div className="logo-container">
                    <img src={nowLogo} alt="now-logo" />
                  </div>
                </CardHeader>
                <CardBody className="text-center">{bodyContent}</CardBody>
                <CardFooter className="text-center">{footerContent}</CardFooter>
                {(this.state.countdown !== null && this.state.countdown > 0) && 
                  <CardFooter className="text-center checkin-countdown">{"Se cancelará en " + this.state.countdown + "s"}</CardFooter>}
              </Card>
            </Col>
          </Container>
        </div>
      </div>
    );
    return (
      <div className="full-page-content">
        <div className="login-page" id="hr-login">
          <Container>
            <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
              <Form>
                <Card className="card-login card-plain text-center">
                  <CardHeader>
                    <div className="logo-container">
                      <img src={nowLogo} alt="now-logo" />
                    </div>
                    <h4>
                      <b>Introduce el PIN</b>
                    </h4>
                  </CardHeader>
                  <CardFooter className="text-center">
                    <Row>
                      <Col xs={12}>
                        <InputGroup
                          className={
                            "form-control-lg " +
                            (this.state.accessPINFocus ? "input-group-focus" : "")
                          }
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="now-ui-icons users_circle-08" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            placeholder="PIN"
                            onFocus={e => this.setState({ accessPINFocus: true })}
                            onBlur={e => this.setState({ accessPINFocus: false })}
                            value={this.state.accessPIN}
                            onChange={(e) => this.setState({ accessPIN: e.target.value})}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                      <Space align="center">
                        <Button
                          block
                          round
                          color={"primary"}
                          size="lg"
                          // href=""
                          // className="mb-3"
                          disabled={!this.validateAccessPIN()}
                          onClick={() =>
                            this.setState({ selectedMethod: PIN_ACCESS })
                          }
                        >
                          <span>Fichar</span>
                        </Button>
                        <Button
                          // block
                          round
                          color="danger"
                          // color={this.state.isLogging ? "default" : "primary"}
                          size="lg"
                          // href=""
                          // className="mb-3"
                          onClick={() =>
                            this.setState({ selectedMethod: null })
                          }
                        >
                          <span>Cambiar método</span>
                        </Button>
                      </Space>
                    {/*<div style={recuperarPassStyle}>
                      <Link to="/recuperar">Recuperar contraseña</Link>
                    </div>*/}
                    {/* this.state.loginError && loginErrorMessage */}
                    {/* <div className="pull-right">
                      <h6>
                        <a href="#pablo" className="link footer-link">
                          Need Help?
                        </a>
                      </h6>
                    </div> */}
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
      </div>
    );
  }
  // End of Build content section
  render() {
    return this.buildCheckinContent();
  }
}

export default CheckIn;



// WEBPACK FOOTER //
// ./src/views/CheckIn/CheckIn.jsx